import { render, staticRenderFns } from "./item-list.vue?vue&type=template&id=811dac00&scoped=true&"
import script from "./item-list.vue?vue&type=script&lang=js&"
export * from "./item-list.vue?vue&type=script&lang=js&"
import style0 from "./item-list.vue?vue&type=style&index=0&id=811dac00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "811dac00",
  null
  
)

export default component.exports